import { useTranslation } from '@pancakeswap/localization'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { multiChainQueryStableClient } from '@/state/info/constant'
import { useChainNameByQuery, useMultiChainPath } from '@/state/info/hooks'
import { v3InfoPath } from '../../constants'
import Link from 'next/link'
import clsx from 'clsx'

export const InfoPageLayout = ({ children }) => {
  const router = useRouter()
  const chainName = useChainNameByQuery()
  const chainPath = useMultiChainPath()
  const isV3 = router?.pathname?.includes(v3InfoPath)
  const { t } = useTranslation()

  const subMenuItems = useMemo(() => {
    const config = [
      {
        label: t('V3'),
        href: `/info/v3${chainPath}`,
      },
      {
        label: t('V2'),
        href: `/info${chainPath}`,
      },
    ]
    if (multiChainQueryStableClient[chainName])
      config.push({
        label: t('StableSwap'),
        href: `/info${chainPath}?type=stableSwap`,
      })
    return config
  }, [t, chainPath, chainName])

  return (
    <div className={'w-[1200px] max-w-full mx-auto px-6'}>
      <div className={'flex justify-end mb-6'}>
        <div className="flex gap-4 text-sm text-muted-foreground">
          <Link
            href={'/explore/v3'}
            className={clsx({
              'text-primary': isV3,
            })}
          >
            V3
          </Link>
          <Link
            href={'/explore'}
            className={clsx({
              'text-primary': !isV3,
            })}
          >
            V2
          </Link>
        </div>
      </div>
      {children}
    </div>
  )
}
